// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__70wSO","disabled":"Pagination_disabled__1nfXP","selected":"Pagination_selected__21Q4B"};